import { render, staticRenderFns } from "./InstructionChip.vue?vue&type=template&id=1cce06f6&scoped=true&"
import script from "./InstructionChip.vue?vue&type=script&lang=js&"
export * from "./InstructionChip.vue?vue&type=script&lang=js&"
import style0 from "./InstructionChip.vue?vue&type=style&index=0&id=1cce06f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cce06f6",
  null
  
)

export default component.exports